import { types } from "mobx-state-tree";
import { AppointmentReason } from "../appointment-reasons/AppointmentReason";
import { Clinic } from "../clinics/Clinic";
import { Pet } from "../pets/Pet";
import { Practitioner } from "../timeslots/Timeslot";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface AppointmentInstance extends Instance<typeof Appointment> {}
export interface AppointmentSnapshotIn extends SnapshotIn<typeof Appointment> {}
export interface AppointmentSnapshotOut
  extends SnapshotOut<typeof Appointment> {}

export const Appointment = types.model("Appointment", {
  id: types.identifier,
  clinic: Clinic,
  reason: AppointmentReason,
  startUtc: types.string,
  endUtc: types.string,
  practitioner: types.maybeNull(Practitioner),
  patients: types.array(Pet),
  instructions: types.string,
  clientNotes: types.string,
  telemedicineRoom: types.maybeNull(
    types.model("TelemedicineRoom", {
      room: types.string,
      url: types.string,
      urlMaster: types.string,
    }),
  ),
  onlineBooking: types.boolean,
  hideAppointmentTime: types.boolean,
});
